(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'animejs', 'react-emotion', '../../styles/colors', '../../elements', './Notification.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('animejs'), require('react-emotion'), require('../../styles/colors'), require('../../elements'), require('./Notification.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global._extends, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.animejs, global.reactEmotion, global.colors, global.elements, global.Notification);
    global.PermanentNotification = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _extends2, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _animejs, _reactEmotion, _colors, _elements, _Notification) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _extends3 = _interopRequireDefault(_extends2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _animejs2 = _interopRequireDefault(_animejs);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n            background-color: ', ';\n            color: ', ';\n            ', ';\n          '], ['\n            background-color: ', ';\n            color: ', ';\n            ', ';\n          ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n                padding: 0 0.2rem;\n              '], ['\n                padding: 0 0.2rem;\n              ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    border-radius: 3px;\n    padding: 0 0 0 16px;\n    font-size: 13px;\n    text-align: left;\n    margin-bottom: 25px;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n    align-items: center;\n    overflow: hidden;\n    margin-top: -100px;\n  '], ['\n    border-radius: 3px;\n    padding: 0 0 0 16px;\n    font-size: 13px;\n    text-align: left;\n    margin-bottom: 25px;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n    align-items: center;\n    overflow: hidden;\n    margin-top: -100px;\n  ']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    min-height: 5rem;\n    align-items: baseline;\n    justify-content: center;\n    padding-bottom: 1.438rem;\n  '], ['\n    display: flex;\n    min-height: 5rem;\n    align-items: baseline;\n    justify-content: center;\n    padding-bottom: 1.438rem;\n  ']),
      _templateObject5 = (0, _taggedTemplateLiteralLoose3.default)(['\n    position: relative;\n    top: 0.2rem;\n    font-size: 1rem;\n  '], ['\n    position: relative;\n    top: 0.2rem;\n    font-size: 1rem;\n  ']),
      _templateObject6 = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-size: 1rem;\n    margin-left: auto;\n    padding-right: 0;\n    cursor: pointer;\n    padding: 23px 16px;\n    outline: none;\n  '], ['\n    font-size: 1rem;\n    margin-left: auto;\n    padding-right: 0;\n    cursor: pointer;\n    padding: 23px 16px;\n    outline: none;\n  ']);

  var Note = _elements.typography.Note;

  var PermanentNotification = function (_Component) {
    (0, _inherits3.default)(PermanentNotification, _Component);

    function PermanentNotification(props) {
      (0, _classCallCheck3.default)(this, PermanentNotification);

      var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this));

      _this.onClose = function () {
        var elementId = _this.state.elementId;

        _animejs2.default.timeline().add((0, _extends3.default)({
          targets: elementId,
          opacity: _this.props.inline ? 1 : 0,
          easing: _this.props.inline ? 'linear' : 'easeOutExpo'
        }, _Notification.animateOut1)).add((0, _extends3.default)({ targets: elementId }, _Notification.animateOut2)).finished.then(_this.onCloseAnimationFinish);
      };

      _this.onCloseAnimationFinish = function () {
        // const el = document.querySelector(selector);
        _this.setState({ visible: false });
        // if (el) el.style.display = 'none';
        if (_this.props.dismissNotification) _this.props.dismissNotification(_this.state.id);
      };

      _this.state = {
        visible: true,
        elementId: '#pjp-notification-' + props.id
      };
      return _this;
    }
    // TODO to talk to product and lock down our colors.


    PermanentNotification.prototype.componentDidMount = function componentDidMount() {
      if (this.props.timeOut === false) return;
      this.timeout = window.setTimeout(this.onClose, 4000);
    };

    PermanentNotification.prototype.componentWillUnmount = function componentWillUnmount() {
      clearTimeout(this.timeout);
    };

    PermanentNotification.prototype.render = function render() {
      var _props = this.props,
          message = _props.message,
          id = _props.id,
          isShowingIcon = _props.isShowingIcon,
          timeOut = _props.timeOut,
          messageLabel = _props.messageLabel,
          border = _props.border,
          backgroundColor = _props.backgroundColor,
          borderColor = _props.borderColor;


      if (!this.state.visible) return _react2.default.createElement('span', null);
      var elementId = 'pjp-notification-' + id;

      return _react2.default.createElement(
        'div',
        {
          id: elementId,
          isShowingIcon: isShowingIcon,
          timeOut: timeOut,
          className: (0, _reactEmotion.cx)(classNames.wrapper, (0, _reactEmotion.css)(_templateObject, backgroundColor, _colors2.default.prussian, border === true ? 'border: solid 1px ' + borderColor + ';' : 'border: none;'), this.props.classNames ? this.props.classNames : ''),
          style: { marginTop: '0px' }
        },
        _react2.default.createElement(
          'div',
          { className: (0, _reactEmotion.cx)(classNames.textWrapper) },
          _react2.default.createElement(
            'span',
            { className: (0, _reactEmotion.cx)('material-icons', classNames.highlightOff) },
            'highlight_off'
          ),
          _react2.default.createElement(
            'span',
            {
              className: (0, _reactEmotion.cx)((0, _reactEmotion.css)(_templateObject2))
            },
            _react2.default.createElement(
              Note,
              { bold: true },
              messageLabel
            ),
            ':\xA0',
            _react2.default.createElement(
              Note,
              null,
              message
            )
          ),
          _react2.default.createElement(
            'span',
            {
              className: (0, _reactEmotion.cx)('material-icons', classNames.closeIcon),
              onClick: this.onClose,
              onKeyPress: this.onClose,
              role: 'button',
              tabIndex: '0'
            },
            isShowingIcon && 'close'
          )
        )
      );
    };

    return PermanentNotification;
  }(_react.Component);

  PermanentNotification.defaultProps = {
    isShowingIcon: false,
    timeOut: false,
    messageLabel: 'Permanent Notification',
    border: false,
    borderColor: '#000',
    classNames: 'pjp-permanent-notification'
  };

  var classNames = {
    wrapper: (0, _reactEmotion.css)(_templateObject3),
    textWrapper: (0, _reactEmotion.css)(_templateObject4),
    highlightOff: (0, _reactEmotion.css)(_templateObject5),
    closeIcon: (0, _reactEmotion.css)(_templateObject6)
  };

  exports.default = PermanentNotification;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/PermanentNotification.js
// module id = 1939
// module chunks = 1